/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-tile',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoTileComponent extends NestedOption {
    @Input()
    get border(): { color?: string, width?: number } {
        return this._getOption('border');
    }
    set border(value: { color?: string, width?: number }) {
        this._setOption('border', value);
    }

    @Input()
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    @Input()
    get hoverStyle(): { border?: { color?: string, width?: number }, color?: string } {
        return this._getOption('hoverStyle');
    }
    set hoverStyle(value: { border?: { color?: string, width?: number }, color?: string }) {
        this._setOption('hoverStyle', value);
    }

    @Input()
    get label(): { font?: DevExpress.viz.Font, textOverflow?: string, visible?: boolean, wordWrap?: string } {
        return this._getOption('label');
    }
    set label(value: { font?: DevExpress.viz.Font, textOverflow?: string, visible?: boolean, wordWrap?: string }) {
        this._setOption('label', value);
    }

    @Input()
    get selectionStyle(): { border?: { color?: string, width?: number }, color?: string } {
        return this._getOption('selectionStyle');
    }
    set selectionStyle(value: { border?: { color?: string, width?: number }, color?: string }) {
        this._setOption('selectionStyle', value);
    }


    protected get _optionPath() {
        return 'tile';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoTileComponent
  ],
  exports: [
    DxoTileComponent
  ],
})
export class DxoTileModule { }
